import moment from 'moment';
import React, { FC } from 'react';
import styled from 'styled-components';
import { FormattedDate } from '../../../components/formatted-date/formatted-date';
import { MrpCodeBadge } from '../../../components/mrp-code-badge/mrp-code-badge';
import { HighlightNegativeQuantity } from '../../../components/quantity/quantity';
import { TD } from '../../../components/table/table';
import { URL_DATE_FORMAT } from '../../../constants/dates';
import { IPlantTransaction } from '../../../graphql/types';
import { Medium } from '../../../styles/fonts';

const StyledText = styled.div`
  font-family: ${Medium};
`;

interface IProductTableBodyProps {
  transaction: IPlantTransaction[];
}

const sortByDate = (a: IPlantTransaction, b: IPlantTransaction) =>
  moment(a.date, URL_DATE_FORMAT)
    .toDate()
    .getTime() -
  moment(b.date, URL_DATE_FORMAT)
    .toDate()
    .getTime();

const ProductTableBody: FC<IProductTableBodyProps> = ({ transaction }) => {
  const [...otherTransactions] = transaction.splice(1);

  const orderedTransactions = [...otherTransactions.sort(sortByDate)];
  return (
    <tbody>
      {orderedTransactions.map(transactions => {
        return (
          <tr
            key={transactions.lineIndex}
            data-value={transactions.lineIndex}
            data-type="transaction"
          >
            <TD data-type="transaction-date">
              <FormattedDate date={transactions.date} />
            </TD>
            <TD data-type="transaction-mrp-element">
              <MrpCodeBadge variant={transactions.mrpElement}>
                {transactions.mrpElement}
              </MrpCodeBadge>
            </TD>
            <TD data-type="transation-element-data">
              {transactions.elementData}
            </TD>
            <TD>
              <StyledText data-type="transaction-customer-name">
                {transactions.customerName}
              </StyledText>
              <div data-type="transaction-customer-id">
                {transactions.customerID}
              </div>
            </TD>
            <TD>
              <HighlightNegativeQuantity
                data-type="transaction-required-quantity"
                quantity={transactions.requiredQuantity}
              >
                {transactions.requiredQuantity}
              </HighlightNegativeQuantity>
            </TD>
            <TD>
              <HighlightNegativeQuantity
                data-type="transaction-calculated-quantity"
                quantity={transactions.calculatedQuantity}
              >
                {transactions.calculatedQuantity}
              </HighlightNegativeQuantity>
            </TD>
          </tr>
        );
      })}
    </tbody>
  );
};

export { ProductTableBody as ProductTransactionDetails };
